import { HttpClient } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }

  private monthChangeSubject = new BehaviorSubject<boolean>(false);
  listenMonthChanged$: Observable<boolean> = this.monthChangeSubject.asObservable();



  /**
   * Retrieves the analysis data for distribution analytics.
   * Makes an HTTP GET request to the distribution analytics endpoint.
   * 
   * @returns Observable containing the analysis data.
   */
  getAnalysisData(): Observable<any> {
    return this.http.get(`${environment.API_BASE_URL}/admin/distribution-analytics`)
  }

  /**
   * Updates the value of the monthChangeSubject, notifying any subscribers
   * of the change in the month value.
   * 
   * @param newValue The new boolean value indicating the month change status.
   */
  changeValue(newValue: boolean) {
    this.monthChangeSubject.next(newValue);
  }

}
